import { addDays } from 'date-fns';
import type { ReactNode } from 'react';
import { type FormattedTimeConfig, type TagMode, WidgetItem } from 'ui';
import type { TodoWidgetDate } from '../../../../types';
import { useTodosWidget } from '../../context';

type P = {
  additionalDescription?: ReactNode;
  additionalDescriptionRows?: number;
  className?: string;
  description?: ReactNode;
  icon: ReactNode;
  item?: ReactNode;
  path: string;
  tags?: TagMode[];
  timeConfig: FormattedTimeConfig;
  title: string;
  type?: 'default' | 'featured';
};

const getActiveDate = (activeKey: TodoWidgetDate) => {
  switch (activeKey) {
    case 'today':
      return new Date();
    case 'tomorrow':
      return addDays(new Date(), 1);
  }
};

const BaseTodoWidgetItem = ({
  additionalDescription,
  additionalDescriptionRows = 2,
  className,
  description,
  icon,
  item,
  path,
  tags,
  timeConfig,
  title,
  type = 'default',
}: P) => {
  const { activeKey } = useTodosWidget();

  return (
    <WidgetItem
      activeDate={getActiveDate(activeKey)}
      additionalDescription={type === 'featured' ? additionalDescription : undefined}
      additionalDescriptionRows={additionalDescriptionRows}
      bordered={type === 'featured'}
      className={className}
      description={description}
      descriptionRows={type === 'featured' ? 1 : 2}
      icon={icon}
      item={item}
      noPadding
      path={path}
      tags={tags}
      timeConfig={timeConfig}
      title={title}
    />
  );
};

export default BaseTodoWidgetItem;
